import React, { Component } from "react";
import "./Certifications.css";
import { Fade } from "react-reveal";
import { certifications, bootcamps } from "../../portfolio";
import CertificationCard from "../../components/certificationCard/CertificationCard";

class Certifications extends Component {
  render() {
    const theme = this.props.theme;
    // Only show the two bootcamps on the first row, centered
    const bootcampCards = bootcamps.bootcamps.map((camp, idx) => (
      <CertificationCard certificate={camp} theme={theme} key={"bootcamp-" + idx} isBootcamp={true} />
    ));
    // Show the rest of the certifications below
    const certCards = certifications.certifications.map((cert, idx) => (
      <CertificationCard certificate={cert} theme={theme} key={"cert-" + idx} />
    ));
    return (
      <div className="main" id="certs">
        <div className="certs-header-div">
          <Fade bottom duration={2000} distance="20px">
            <h1 className="certs-header" style={{ color: theme.text }}>
              Certifications & Bootcamps
            </h1>
          </Fade>
        </div>
        <div className="certs-body-div">
          <div className="bootcamps-row" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', gap: '32px', marginBottom: '32px' }}>
            {bootcampCards}
          </div>
          {certCards}
        </div>
      </div>
    );
  }
}

export default Certifications;
